import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import { Link } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";

function Header() {
  const [{ cart, user }, dispatch] = useStateValue();

  const handleAuth = () => {
    if (user) {
      auth.signOut();
    }
  };

  return (
    <div className="header">
      <Link to="/">
        <img
          className="header__logo"
          src="https://pngimg.com/uploads/amazon/amazon_PNG25.png"
        />
      </Link>
      <div className="header__search">
        <input className="header__searchText" type="text" />
        <SearchIcon className="header__searchIcon" />
      </div>
      <div className="header__features">
        <Link to="/login">
          <div className="header__feature" onClick={handleAuth}>
            <span className="header__featureLineOne">
              {user ? "Hello " + user?.email : "Hello Guest"}
            </span>
            <span className="header__featureLineTwo">
              {user ? "Sign out" : "Sign in"}
            </span>
          </div>
        </Link>
        <Link to="/orders">
          <div className="header__feature">
            <span className="header__featureLineOne">Return</span>
            <span className="header__featureLineTwo">& Orders</span>
          </div>
        </Link>
        <div className="header__feature">
          <span className="header__featureLineOne">Your</span>
          <span className="header__featureLineTwo">Prime</span>
        </div>

        <Link to={user ? "/checkout" : "/login"}>
          <div className="header__featureBasket">
            <ShoppingBasketIcon />
            <span className="header__featureLineTwo header_basketCount">
              {cart?.length}
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Header;
